module.exports = __webpack_public_path__ + "img/图层 17.cafc51d9.png";